
import {Component} from './base';

export class EventComponent extends Component {
  public static shouldLoad() {
    return $('.has-tooltip').length > 0;
  }

  public load() {
    $('.has-tooltip').tooltip();
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/event.ts